<template>
    <div class="favourite">
        <div v-if="active">
            <div class="text-center" @click="unfavourite()">
                <img src="/icons/star-icon-yellow.svg" alt="favourite" >
                <span v-if="isClub">Favourite</span>
            </div>
        </div>
        <div v-else>
            <div class="text-center" @click="favourite()">
                <img src="/icons/star-icon-black.svg" alt="favourite" >
                <span v-if="isClub">Add to favourites</span>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'


export default {
    data() {
        return {
            list: this.listProp,
            active: false,
        }
    },

    props: [
        'listProp', 'favouriteUrl', 'hashid', 'isClub'
    ],


    computed: {
        
    },

    created() {

    },

    mounted() {
        if(this.list.length > 0) {
            this.list.forEach(element => {
                if(element['id'] === this.hashid) {
                    this.active = true;
                }
            });
        }
    },

    watch: {
    },

    methods: {
        
        favourite() {
            axios
                .post(this.favouriteUrl,
                    {
                        params: {
                            
                        }
                    }
                )
                .then(response => {
                    this.active = true;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        unfavourite() {
            axios
                .delete(this.favouriteUrl,
                    {
                        params: {
                            
                        }
                    }
                )
                .then(response => {
                    this.active=false
                })
                .catch(error => {
                    console.log(error);
                });
        }
    },
}
</script>
